import { createAction, props } from "@ngrx/store";

export const incrementAction = createAction("[Test Component] Increment", props<{ payload: { count: number } }>());
